var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { TextBubble } from '../elements/text-bubble';
var cls = classNames('site-lang-menu-button');
export var SiteLangMenuButtonDefaultProps = {
  size: 32,
  colors: {
    text: 'light',
    background: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-transform: uppercase;\n  "], ["\n    text-transform: uppercase;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(TextBubble)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SiteLangMenuButton = function (props) {
  var className = props.className,
    size = props.size,
    children = props.children,
    colors = props.colors,
    onClick = props.onClick,
    entity = props.entity;
  return React.createElement(My.Container, {
    size: size,
    onClick: onClick,
    colors: colors,
    className: cls.name(className)
  }, children);
};
SiteLangMenuButton.defaultProps = SiteLangMenuButtonDefaultProps;
SiteLangMenuButton.cls = cls;
var templateObject_1, templateObject_2;